module.exports = __webpack_public_path__ + "img/1-3.06d784a3.jpg";